import { APP_FLOW } from "../../common/constant"

export const getAppFlow = () => {
    return (
        sessionStorage.getItem("flowType") === APP_FLOW.FIDYAH ||
        window.location.pathname.includes("fidyah")
    ) ? APP_FLOW.FIDYAH : APP_FLOW.ZAKAT;
}